export interface RdsDataProductSelection {
  catalogId: string;
  dataProductId: string;
}
